import React from 'react';
import ErrorMessage from '../../components/common/ErrorMessage/ErrorMessage';

const ObjectTypeSelector = ({
    objectTypeOptions,
    subTypesMap,
    objectTypes,
    disabled,
    error,
    onTypeChange,
}) => {
    const getSubTypeCheckState = (parentKey) => {
        const subs = subTypesMap[parentKey];
        if (!subs) return objectTypes[parentKey] ? 'all' : 'none';
        const anyChecked = subs.some(s => objectTypes[s.key]);
        const allChecked = subs.every(s => objectTypes[s.key]);
        if (allChecked) return 'all';
        if (anyChecked) return 'partial';
        return 'none';
    };

    const selectAllOption = objectTypeOptions.find(o => o.key === 'selectAll');
    const expandableOptions = objectTypeOptions.filter(o => o.hasSubTypes);
    const flatOptions = objectTypeOptions.filter(o => !o.hasSubTypes && o.key !== 'selectAll');

    const renderExpandable = (option) => {
        const subTypes = subTypesMap[option.key] || [];
        const checkState = getSubTypeCheckState(option.key);
        return (
            <div key={option.key} className="object-type-cell">
                {/* Parent row — no chevron, always expanded */}
                <div className="object-type-parent">
                    <label className="object-type-checkbox">
                        <input
                            type="checkbox"
                            checked={checkState === 'all'}
                            ref={el => { if (el) el.indeterminate = checkState === 'partial'; }}
                            onChange={() => onTypeChange(option.key)}
                            disabled={disabled}
                        />
                        <span>{option.label}</span>
                    </label>
                </div>

                {/* Subtypes — always visible, with dotted branch lines */}
                <div className="object-type-subtypes object-type-subtypes--tree">
                    {subTypes.map((sub, idx) => {
                        const isLast = idx === subTypes.length - 1;
                        return (
                            <div
                                key={sub.key}
                                className={`object-type-tree-item${isLast ? ' object-type-tree-item--last' : ''}`}
                            >
                                <label className="object-type-checkbox">
                                    <input
                                        type="checkbox"
                                        checked={objectTypes[sub.key]}
                                        onChange={() => onTypeChange(sub.key)}
                                        disabled={disabled}
                                    />
                                    <span>{sub.label}</span>
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    return (
        <>
            <div className="object-types-container">
                {/* Select All row */}
                {selectAllOption && (
                    <div className="object-types-select-all-row">
                        <label className="object-type-checkbox">
                            <input
                                type="checkbox"
                                checked={objectTypes[selectAllOption.key]}
                                onChange={() => onTypeChange(selectAllOption.key)}
                                disabled={disabled}
                            />
                            <span>{selectAllOption.label}</span>
                        </label>
                    </div>
                )}

                {/* Two-panel layout: expandable types left, flat types right */}
                <div className="object-types-layout">
                    {/* Left panel: Table + View, always expanded, with tree lines */}
                    <div className="object-types-expandable-panel">
                        {expandableOptions.map(renderExpandable)}
                    </div>

                    {/* Right panel: flat options in a 2-column grid */}
                    <div className="object-types-flat-panel">
                        {flatOptions.map(option => (
                            <div key={option.key} className="object-type-cell">
                                <label className="object-type-checkbox">
                                    <input
                                        type="checkbox"
                                        checked={objectTypes[option.key]}
                                        onChange={() => onTypeChange(option.key)}
                                        disabled={disabled}
                                    />
                                    <span>{option.label}</span>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <ErrorMessage message={error} />
        </>
    );
};

export default ObjectTypeSelector;